import PropTypes from 'prop-types';
import React from 'react';
import styles from './VideoHotspot.module.css';
export default function VideoHotspot(_a) {
    var left = _a.left, top = _a.top, width = _a.width, height = _a.height, externalUrl = _a.externalUrl;
    var style = { left: left, top: top, width: width, height: height };
    return (React.createElement("video", { className: styles.video, controls: true, controlsList: "nodownload", style: style },
        React.createElement("source", { src: externalUrl })));
}
VideoHotspot.propTypes = {
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    externalUrl: PropTypes.string.isRequired,
};
